import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "@/lib/api";

export default function AnnouncementModal() {
  const [ann, setAnn] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/announcement")
      .then((r) => { if (alive && r.data?.show) setAnn(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const close = () => {
    if (ann?.frequency === "once") {
      api.post("/announcement/seen").catch(() => {});
    }
    setAnn(null);
  };

  if (!ann) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
      data-testid="announcement-overlay"
      onClick={close}
    >
      <div
        className="relative w-full max-w-md overflow-hidden rounded-2xl border border-[#00E676]/30 bg-[#0F1812] shadow-[0_0_50px_rgba(0,230,118,0.25)] animate-in fade-in zoom-in-95 duration-200"
        data-testid="announcement-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={close}
          data-testid="announcement-close"
          className="absolute top-3 right-3 z-10 grid h-9 w-9 place-items-center rounded-full bg-black/50 text-white hover:bg-[#00E676] hover:text-[#04180a] transition-colors"
        >
          <X size={18} />
        </button>

        {ann.image ? (
          <img src={ann.image} alt="" className="w-full max-h-64 object-cover" data-testid="announcement-image" />
        ) : null}

        <div className="p-6 space-y-3">
          {ann.title ? (
            <h2 className="font-script text-3xl text-[#39FF14]" data-testid="announcement-title">{ann.title}</h2>
          ) : null}
          {ann.text ? (
            <p className="text-[#E7F5EC] whitespace-pre-wrap leading-relaxed" data-testid="announcement-text">{ann.text}</p>
          ) : null}
          <button
            onClick={close}
            data-testid="announcement-ok"
            className="mt-2 w-full py-3 rounded-lg font-bold text-[#04180a] bg-gradient-to-r from-[#00E676] to-[#39FF14] hover:opacity-90 transition-opacity"
          >
            J'ai compris
          </button>
        </div>
      </div>
    </div>
  );
}
